var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vc-home-footer vc-w-100 pt-0 pb-0 pl-8 pr-8"},[_c('div',{staticClass:"white--text date"},[_vm._v(" "+_vm._s(_vm.todayString)+" ")]),_c('div',{staticClass:"white--text"},[_vm._v(" Versão 0.1.0 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }